import React, { useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Paper, Typography } from '@material-ui/core';
import RMSCommonDialog from '../../../shared/components/dialog/RMSCommonDialog';
import { RMSButton } from '../../../shared/components/buttons';
import { RMSSignaturePad } from '../../../shared/components/form-controls';
import { executeApiAction } from '../../../shared/utility/apiHelper';
import { notify } from 'reducers/NotifierReducer';
import { changeSignature } from '../../services/userSignatureService';

const ChangeSignatureDrawDialog = ({ open, pin, onClose, onSaved }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [signatureEmpty, setSignatureEmpty] = useState(true);
  const signatureRef = useRef(null);

  const handleClear = () => {
    signatureRef.current?.clear();
  };

  const handleSave = async () => {
    const signatureImage = signatureRef.current?.getSignature();
    if (!signatureImage) {
      return;
    }

    await executeApiAction({
      setLoading,
      dispatch,
      action: () => changeSignature({ pin, signatureData: signatureImage }),
      onSuccess: () => {
        dispatch(notify('Signature updated successfully', 'success'));
        onSaved?.();
        onClose();
      },
    });
  };

  return (
    <RMSCommonDialog
      open={open}
      title="Draw New Signature"
      onClose={onClose}
      loading={loading}
      maxWidth="sm"
      fullWidth
      closeOnBackdropClick={false}
      saveButton={{ show: false }}
      cancelButton={{ show: false }}
      dialogClassName="change-signature-dialog">
      <Typography className="setup-signature-instruction">Draw your new signature:</Typography>

      <Paper variant="outlined" className="signature-card">
        <div className="signature-card-header">
          <Typography className="signature-title">Collect Signature</Typography>
          <RMSButton label="Clear" variant="outlined" onClick={handleClear} />
        </div>

        <RMSSignaturePad ref={signatureRef} height={180} onChange={setSignatureEmpty} />

        <div className="signature-footer">
          <RMSButton label="Cancel" variant="outlined" onClick={onClose} />
          <RMSButton
            label="Save Signature"
            color="primary"
            disabled={signatureEmpty}
            onClick={handleSave}
          />
        </div>
      </Paper>
    </RMSCommonDialog>
  );
};

export default ChangeSignatureDrawDialog;
